export const GroupType = {
  STATIC: 'static',
  SEGP: 'segp',
};
